// ** UseJWT import to get config
import atlasApi from '..'

const Login = async (credentials) => {
  const { email, password } = credentials

  try {
    const response = await atlasApi.post('/auth/validate', {
      email,
      password
    })

    const accessToken = response.data.token
    delete response.data.token

    const userData = { ...response.data }

    userData.ability = []

    Object.entries(userData.capabilities).forEach((ability) => {
      const [key, value] = ability
      if (key !== 'read') {
        userData.ability.push({
          action: value.toString(),
          subject: key
        })
      }
    })

    const responseData = {
      userData,
      accessToken
      // refreshToken
    }

    return [200, responseData]
  } catch (error) {
    return [error.response.status, error]
  }
}

const Register = async (newUser) => {
  try {
    const { name, corporate_name, cnpj, email, username, password, ...rest } =
      newUser

    const response = await atlasApi.post('/auth/users', {
      name,
      corporate_name,
      cnpj,
      email,
      username,
      password,
      ...rest
    })

    const { accessToken, refreshToken, ...userData } = response.data

    userData.ability = []

    Object.entries(userData.capabilities).forEach((ability) => {
      const [key, value] = ability
      if (key !== 'read') {
        userData.ability.push({
          action: value.toString(),
          subject: key
        })
      }
    })

    userData.ability.push({
      action: 'read',
      subject: 'commom'
    })

    const responseData = {
      userData,
      accessToken,
      refreshToken,
      status: response.status
    }

    // return [200, responseData]
    return responseData
  } catch (error) {
    return error.response
    // return [error.response.status, error.response.data]
  }
}

const Session = async (token) => {
  try {
    atlasApi.interceptors.request.use(
      (config) => {
        // ** Get token from localStorage
        const accessToken = token

        // ** If token is present add it to request's Authorization Header
        if (accessToken) {
          config.headers.Authorization = `Bearer ${accessToken}`
        }
        return config
      },
      (error) => Promise.reject(error)
    )

    const response = await atlasApi.post('/auth/sessions')

    if (response.status !== 200) {
      return { isValid: false }
    } else {
      const data = {
        userData: response.data,
        accessToken: token
        // refreshToken: responseData.refreshToken,
      }
      data.userData.ability = []
      Object.entries(data.userData.capabilities).forEach((ability) => {
        const [key, value] = ability
        if (key !== 'read') {
          data.userData.ability.push({
            action: value.toString(),
            subject: key
          })
        }
      })

      data.userData.ability.push({
        action: 'read',
        subject: 'commom'
      })
      return { data, isValid: true }
    }
  } catch (error) {
    // return [400, { error }];
    return { isValid: false }
  }
}

export { Login, Register, Session }
